// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AuthService } from "../api";
import { toast } from "react-toastify";
import { ACCESS_TOKEN, USER_KEY } from "../../utility/auth";

// export const actionLogin = createAsyncThunk(
//   "authentication/login",
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await AuthService.doLogin(data);

//       if (!res.data.status) {
//         const { userData, accessToken } = res.data.data;
//         toast.success(res.data.message);
//         localStorage.setItem(USER_KEY, JSON.stringify(userData));
//         localStorage.setItem(ACCESS_TOKEN, JSON.stringify(accessToken));
//         return { userData, accessToken };
//       } else {
//         toast.error(res.data.message);
//         return rejectWithValue(res.data);
//       }
//     } catch (error) {
//       const message = error.response?.data?.message || error.message;
//       toast.error(message);
//       return rejectWithValue(message);
//     }
//   }
// );

export const actionLogin = createAsyncThunk(
  "authentication/login",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AuthService.doLogin(data);
      if (!res.error) {
        toast.success(res.data.message);
        localStorage.setItem(USER_KEY, JSON.stringify(res.data.data));
        localStorage.setItem(ACCESS_TOKEN, res.data.data.accessToken);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data.message);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionRegister = createAsyncThunk(
  "authentication/register",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AuthService.doRegister(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
      // return error.response;
    }
  }
);

export const actionForgotPass = createAsyncThunk(
  "authentication/forgotPass",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AuthService.doForgot(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
      // return error.response;
    }
  }
);

export const actionVerifyEmailpass = createAsyncThunk(
  "authentication/verifyEmailpass",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AuthService.doVerifyEmailpass(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
      // return error.response;
    }
  }
);

export const actionChangePass = createAsyncThunk(
  "authentication/changePass",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AuthService.doChangePass(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);

      return rejectWithValue(message);
      // return error.response;
    }
  }
);

export const actionDeleteAccount = createAsyncThunk(
  "authentication/delete_account",
  async (data) => {
    try {
      const res = await AuthService.doDeleteAccount(data);

      if (res.status === 200) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return res.data;
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return message;
      // return error.response;
    }
  }
);

export const actionDeleteTypeAccount = createAsyncThunk(
  "authentication/delete_type_account",
  async (data) => {
    try {
      const res = await AuthService.doDeleteTypeAccount(data);
      if (res.status === 200) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return res.data;
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return message;
      // return error.response;
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    login: {
      loading: false,
      data: null,
      error: "",
    },
    register: {
      loading: false,
      data: null,
      error: "",
    },
    forgot: {
      loading: false,
      data: null,
      error: "",
    },
    reset: {
      loading: false,
      data: null,
      error: "",
    },
    verifyEmailpass: {
      loading: false,
      data: null,
      error: "",
    },
    changePass: {
      loading: false,
      data: null,
      error: "",
    },
    deleteAccount: {
      loading: false,
      data: null,
      error: "",
    },
    deleteTypeAccount: {
      loading: false,
      data: null,
      error: "",
    },
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      // login
      .addCase(actionLogin.pending, (state) => {
        state.login.loading = true;
      })
      .addCase(actionLogin.fulfilled, (state, action) => {
        state.login.loading = false;
        state.login.data = action.payload;
      })
      .addCase(actionLogin.rejected, (state, action) => {
        state.login.loading = false;
        state.login.error = action.error.message || "Something went wrong";
      })
      // register
      .addCase(actionRegister.pending, (state) => {
        state.register.loading = true;
      })
      .addCase(actionRegister.fulfilled, (state, action) => {
        state.register.loading = false;
        state.register.data = action.payload;
      })
      .addCase(actionRegister.rejected, (state, action) => {
        state.register.loading = false;
        state.register.error = action.error.message || "Something went wrong";
      })
      // Forgot
      .addCase(actionForgotPass.pending, (state) => {
        state.forgot.loading = true;
      })
      .addCase(actionForgotPass.fulfilled, (state, action) => {
        state.forgot.loading = false;
        state.forgot.data = action.payload;
      })
      .addCase(actionForgotPass.rejected, (state, action) => {
        state.forgot.loading = false;
        state.forgot.error = action.error.message || "Something went wrong";
      })
      // verifyEmailpass
      .addCase(actionVerifyEmailpass.pending, (state) => {
        state.verifyEmailpass.loading = true;
      })
      .addCase(actionVerifyEmailpass.fulfilled, (state, action) => {
        state.verifyEmailpass.loading = false;
        state.verifyEmailpass.data = action.payload;
      })
      .addCase(actionVerifyEmailpass.rejected, (state, action) => {
        state.verifyEmailpass.loading = false;
        state.verifyEmailpass.error =
          action.error.message || "Something went wrong";
      })
      //.deleteAccount
      .addCase(actionDeleteAccount.pending, (state, action) => {
        state.deleteAccount.loading = true;
      })
      .addCase(actionDeleteAccount.rejected, (state, action) => {
        state.deleteAccount.loading = false;
        state.deleteAccount.error = action.payload;
        state.deleteAccount.data = {};
      })
      .addCase(actionDeleteAccount.fulfilled, (state, action) => {
        state.deleteAccount.loading = false;
        state.deleteAccount.data = action.payload;
        state.deleteAccount.error = "";
      })
      //.deleteTypeAccount
      .addCase(actionDeleteTypeAccount.pending, (state, action) => {
        state.deleteTypeAccount.loading = true;
      })
      .addCase(actionDeleteTypeAccount.rejected, (state, action) => {
        state.deleteTypeAccount.loading = false;
        state.deleteTypeAccount.error = action.payload;
        state.deleteTypeAccount.data = {};
      })
      .addCase(actionDeleteTypeAccount.fulfilled, (state, action) => {
        state.deleteTypeAccount.loading = false;
        state.deleteTypeAccount.data = action.payload;
        state.deleteTypeAccount.error = "";
      })
      // change pass
      .addCase(actionChangePass.pending, (state) => {
        state.changePass.loading = true;
      })
      .addCase(actionChangePass.fulfilled, (state, action) => {
        state.changePass.loading = false;
        state.changePass.data = action.payload;
      })
      .addCase(actionChangePass.rejected, (state, action) => {
        state.changePass.loading = false;
        state.changePass.error = action.error.message || "Something went wrong";
      });
  },
});

export default authSlice.reducer;
export const { actions, reducer } = authSlice;
